import { CLEAR_TALENT_INFO, SET_TALENT_INFO } from './../constants';

const initialState = {
  id: '',
  internalIds: [],
  name: '',
  filter: 'all',
  roles: [],
  searchRoles: [],
  contents: [],
};

export const talentInfo = (state = initialState, action) => {
  switch (action.type) {
    case SET_TALENT_INFO:
      return {
        ...state,
        id: action.payload.id,
        internalIds: action.payload.internalIds,
        name: action.payload.name,
        roles: [...action.payload.roles],
        searchRoles: [...action.payload.searchRoles],
      };
    case CLEAR_TALENT_INFO:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default talentInfo;
